'use strict';


$(document).ready(function () {
  
  $('.btn-show-details').on('click', function () {
    var form = $(this).closest('form');
    form.attr('data-address-mode', 'details');
    form.find('.multi-ship-address-actions').removeClass('d-none');
    form.find('.multi-ship-action-buttons .col-12.btn-save-multi-ship').addClass('d-none');
  });

  $('.btn-add-new').on('click', function () {
    var $el = $(this);
    if ($el.parents('#dwfrm_billing').length > 0) {
        // Handle billing address case
        $('body').trigger('checkout:clearBillingForm');
        var $option = $($el.parents('form').find('.addressSelector option')[0]);
        $option.attr('value', 'new');
        var $newTitle = $('#dwfrm_billing input[name=localizedNewAddressTitle]').val();
        $option.text($newTitle);
        $option.prop('selected', 'selected');
        $el.parents('[data-address-mode]').attr('data-address-mode', 'new');
    } else {
        // Handle shipping address case
        var $newEl = $el.parents('form').find('.addressSelector option[value=new]');
        $newEl.prop('selected', 'selected');
        $newEl.parent().trigger('change');
    }

    //reset form
    let form = document.querySelectorAll(".shipping-address");
    let campos = form[0].querySelectorAll("input");
    campos.forEach((i) => i.value = "");
  });


  $(".single-shipping .addressSelector").on("change", function () {
    console.log('sjsdhjdsjdshd');
    var e = $(this).parents("form")[0],
      t = $("option:selected", this),
      i = t.data(),
      n = t[0].value,
      r = $("input[name=shipmentUUID]", e).val();
    Object.keys(i).forEach(function (t) {
      $("[name$=" + ("countryCode" === t ? "country" : t) + "]", e).val(
        i[t]
      );
    }),
      $("[name$=stateCode]", e).trigger("change"),
      "new" === n
        ? ($(e).attr("data-address-mode", "new"),
          $(e).find(".shipping-address-block").removeClass("d-none"))
        : n === r
        ? $(e).attr("data-address-mode", "shipment")
        : 0 === n.indexOf("ab_")
        ? $(e).attr("data-address-mode", "customer")
        : $(e).attr("data-address-mode", "edit");
  });
  
});